import React, { useState } from "react";
import api, { API_BASE_URL } from "../../../../api/api";
import { CONSTANT_REDIRECT_TIME } from "../../../../constant/common";
import { toast } from "react-toastify";
import { getInitials } from "../../../../utils/helper";
import { formatDateForView } from "../../../../utils/formateDate";

const PracticeReviewsCard = ({
    item,
    practice
}) => {

    return (
        <>
            <div className="p-[18px] border border-solid border-[#bbb] rounded-2xl mb-3">

                <div className="flex gap-3 justify-between items-center flex-wrap mb-3">
                    <div className="flex gap-3 items-center">
                        <div className="rounded-full h-12 w-12 flex items-center justify-center bg-gray-400 text-white font-semibold text-lg overflow-hidden">
                            {getInitials(item?.name)}
                        </div>
                        <div>
                            <h3 className="text-dark font-semibold text-base">{item?.name}</h3>
                            <p className="text-dark font-normal text-xs">{formatDateForView(item?.created_date)}</p>
                        </div>
                    </div>
                </div>
                <div className="flex gap-1 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <img
                            key={star}
                            src={item.rate >= star ? "/assets/image/star.svg" : "/assets/image/balnkstar.svg"}
                            alt={`Star ${star}`}
                        />
                    ))}
                </div>
                <p className="text-sm text-dark font-normal text-justify mb-3">
                    {item?.message}
                </p>
                {item?.reply != null && (
                    <div className="flex justify-start mt-6">
                        <div className="rounded-xl">
                            <div className="flex items-center justify-start gap-2 mb-3">

                                <div className="rounded-full h-12 w-12 flex items-center justify-center bg-gray-400 text-white font-semibold text-lg overflow-hidden">
                                    {getInitials(practice?.practice_name)}
                                </div>
                                <div>
                                    <h3 className="text-dark font-semibold text-base">{practice?.practice_name} (Owner)</h3>
                                    <p className="text-dark font-normal text-xs">{formatDateForView(item?.reply_date)}</p>
                                </div>
                            </div>
                            <p className="text-sm text-dark font-normal">{item?.reply}</p>
                        </div>
                    </div>
                )}

            </div>
        </>
    )
};

export default PracticeReviewsCard;
